import React from 'react';
import { Image as BuilderImage } from '@builder.io/react';

import { FontAwesomeIcon } from "../../libs/fonts"

const TeamCard = ({ photo, name, title, socialUrl, socialNetwork }) => (
  <div className="col-md-6">
    <div className="team-item">
      <div className="team-inner-wrap">
        <div className="images-wrap">
          <BuilderImage image={photo} alt={`A photo of ${name}`} />
        </div>
        <div className="team-content">
          <h3 className="title-name" style={{ marginBottom: 6 }}>
            {name}
            {(socialNetwork && socialUrl) && (
              <a href={socialUrl}>
                <FontAwesomeIcon
                  className='ml-8'
                  icon={`fa-brands fa-${socialNetwork}`}
                  style={{ color: 'black' }}
                />
                <span style={{ display: 'none' }}>Social network link</span>
              </a>
            )}
          </h3>
          <p className='team-title mb-0'>{title}</p>
        </div>
      </div>
    </div>
  </div>
);

export default TeamCard;
